import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, first, Observable, Subject } from 'rxjs';
import * as config from '../../config/app.config';
import { PaymentsMods } from '../../config/app.config';
import { BaseService } from '../../services/base.service';
import { DataLayerService } from '../../services/data-layer.service';
import { SharedService } from '../../services/shared.service';
import { map } from 'rxjs/operators';
import { B2bUserService } from "../../services/b2b-user.service";

@Injectable({
  providedIn: 'root',
})
export class CheckoutService {
  private readonly b2bUserService = inject(B2bUserService);
  updatedContact: any;
  orderDataForinlfuenza: any;
  userAccountData: any;
  public emails = new BehaviorSubject<any>(false);
  emails$ = this.emails.asObservable();
  updatedOrderDetails: any;
  public updatedStdOrderDetails = new BehaviorSubject<any>(false);
  updatedStdOrderDetails$ = this.updatedStdOrderDetails.asObservable();
  public updatedPOnumberDetails = new Subject<any>();
  public userAccountDetails = new BehaviorSubject<any>(false);
  public userAccountDetails$ = this.userAccountDetails.asObservable();
  paymentModes: Subject<any>;
  constructor(
    private readonly baseService: BaseService,
    private readonly sharedService: SharedService,
    private readonly dataLayerService: DataLayerService
  ) {
    this.updatedContact = new Subject();
    this.updatedOrderDetails = new Subject();
    this.paymentModes = new Subject();
  }

  updateContact(params, userId, cartId): void {
    this.baseService
      .post(
        config.USER_ACCOUNT +
          userId +
          '/saveOrderContact?cartId=' +
          cartId +
          '&fields=DEFAULT',
        params
      )
      .subscribe((res) => {
        if (res) {
          this.updatedContact.next(res);
        }
      });
  }
  getEmails(userId, b2bUnitID): void {
    this.emails.next(false);
    this.baseService
      .get(
        config.USER_ACCOUNT + userId + '/customerEmails?b2bUnitId=' + b2bUnitID
      )
      .subscribe((res) => {
        if (res) {
          this.emails.next(res);
        }
      });
  }
  checkPOnumber(userId, orderNo, params): void {
    this.baseService
      .post(
        config.USER_ACCOUNT +
          userId +
          '/check-order-po-number?poNumber=' +
          orderNo +
          '&fields=DEFAULT',
          params
      )
      .subscribe((res) => {
          this.updatedPOnumberDetails.next(res);
      });
  }
  updateOrder(userId, cartId, params): void {
    this.updatedStdOrderDetails.next(false);
    this.updatedOrderDetails.next(false);
    this.baseService
      .post(
        config.USER_ACCOUNT +
          userId +
          '/place-multiple-orders?cartId=' +
          cartId +
          '&fields=DEFAULT',
        params
      )
      .subscribe((res) => {
        console.log(res);
        if (res) {
          this.orderDataForinlfuenza = res;
          this.sharedService.setSessionStorage(
            'orderDataForinlfuenza',
            this.orderDataForinlfuenza
          );
          if (res?.cartType === 'INFLUENZA') {
            this.updatedOrderDetails.next(res);
          } else {
            this.updatedStdOrderDetails.next(res);
            this.dataLayerService.purchaseDataLayer(res);
          }
          res?.orders.forEach(order => {
            localStorage.setItem('order_number', order?.code);
          });
        }
      }
      ,
      (err) => {console.log('HTTP Error', err);
        this.updatedStdOrderDetails.next(err);
        this.updatedOrderDetails.next(err);
      })
  }

  public getUserAccountDataFromDb(userId): void {
    this.userAccountData = new Subject<any>();
    this.baseService
      .get(`${config.USER_ACCOUNT}${userId}/b2bUnits/`, { fields: 'FULL' })
      .subscribe((res) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          this.userAccountData.next({ res });
        }
      });
  }
  public getUserAccountDetailsDataFromDb(userId, accountId): void {
    this.baseService
      .get(`${config.USER_ACCOUNT}${userId}/b2bUnits/${accountId}`, {
        fields: 'FULL',
      })
      .subscribe((res) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          this.userAccountDetails.next({ res });
        }
      });
  }


  public getPaymentModes() {
    this.baseService
      .get(`${config.GET_PAYMENTMODES}`)
      .subscribe((res) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          this.paymentModes.next(res);
        }
      });
  }

  getPaymentModesMapped(userId): Observable<PaymentsMods[]> {
    return this.baseService
      .get(`${config.USER_ACCOUNT}${userId}${config.GET_PAYMENTMODES}`)
      .pipe(
        first(res => res?.paymentModes),
        map((res: any) => res.paymentModes.map(mode => mode.code) as PaymentsMods[])
      )
  }
}